import __vue_normalize__ from '@gig/magic-wand/dist/build/rollup/vue-helpers/normalize-component.js';
import __vue_create_injector__ from 'vue-runtime-helpers/dist/inject-style/browser.mjs';
import magicStyles from './email.magic.css.js';
import script from './email.js';

const __vue_script__ = script;

/* template */
var __vue_render__ = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrapper"},[_c('magic-ui-text',{staticClass:"introduction",attrs:{"tag":"p","data-v-test-id":"step3-email-text","content":_vm.$t('sign-up-step-three.email.introduction')}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"email",attrs:{"tag":"p","content":_vm.email}}),_vm._v(" "),_c('magic-ui-text',{staticClass:"instructions",attrs:{"tag":"p","data-v-test-id":"step3-instructions-text","content":_vm.instructions}}),_vm._v(" "),_c('div',{staticClass:"action"},[(_vm.showEmailClientCTA && _vm.verificationEmailClients)?_c('a',{staticClass:"info-link",attrs:{"target":"_blank","rel":"noopener noreferrer","href":_vm.emailClientURL}},[_c('magic-ui-button',{attrs:{"wide":"","variant":"primary","data-v-test-id":"step3-email-button"},domProps:{"innerHTML":_vm._s(_vm.emailClientText)}})],1):_vm._e(),_vm._v(" "),_c('div',{staticClass:"help-container",attrs:{"data-v-test-id":"step3-help-container"}},[_c('magic-ui-text',{staticClass:"help-text",attrs:{"tag":"span","data-v-test-id":"step3-help-text","content":_vm.$t('sign-up-step-three.email.help-text')}}),_vm._v(" "),_c('magic-ui-link',{staticClass:"link",attrs:{"data-v-test-id":"step3-livechat-link","to":_vm.RoutablePage.LIVE_CHAT}},[_vm._v("\n                "+_vm._s(_vm.$t('sign-up-step-three.email.help'))+"\n            ")])],1)])],1)};
var __vue_staticRenderFns__ = [];

  /* style */
  const __vue_inject_styles__ = function (inject) {
    if (!inject) return
    inject("data-v-5a56ac8d_0", { source: magicStyles, map: undefined, media: undefined });

  };
  /* scoped */
  const __vue_scope_id__ = "data-v-5a56ac8d";
  /* module identifier */
  const __vue_module_identifier__ = undefined;
  /* functional template */
  const __vue_is_functional_template__ = false;
  /* style inject SSR */
  
  /* style inject shadow dom */
  

  
  const __vue_component__ = /*#__PURE__*/__vue_normalize__(
    { render: __vue_render__, staticRenderFns: __vue_staticRenderFns__ },
    __vue_inject_styles__,
    __vue_script__,
    __vue_scope_id__,
    __vue_is_functional_template__,
    __vue_module_identifier__,
    false,
    __vue_create_injector__,
    undefined,
    undefined
  );

export default __vue_component__;
